The component this is responding to.
